export const addBlinkAnimation = (storyIds: string[], timeout = 1000) => {
  for (const storyId of storyIds) {
    const storyElements = document.querySelectorAll(`[id^="story_${storyId}"]`)
    for (const element of storyElements) {
      switch (true) {
        case element instanceof HTMLFormElement: {
          element.classList.add('animate-blink-yellow')
          setTimeout(() => element.classList.remove('animate-blink-yellow'), timeout)
          break
        }
        default: {
          const cardContent = element.querySelector('[class*="bg-surface-"]')
          if (cardContent) {
            cardContent.classList.add('animate-blink-yellow')
            setTimeout(() => cardContent.classList.remove('animate-blink-yellow'), timeout)
          }
        }
      }
    }
  }
}
